var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNewConversations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.122 86.5",
    width: 93,
    height: 86,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#205763",
    d: "M0 0h93.122v86.5H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#205763",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.505 86.5a3.886 3.886 0 0 1-3.884-3.882v-8.9h-5.82a7.769 7.769 0 0 1-7.76-7.76V32.98a7.769 7.769 0 0 1 7.76-7.76h46.561a7.769 7.769 0 0 1 7.76 7.76v32.981a7.769 7.769 0 0 1-7.76 7.76H62.885l-11.64 11.64a3.871 3.871 0 0 1-2.74 1.138m-9.7-57.4a3.885 3.885 0 0 0-3.88 3.88V65.96a3.885 3.885 0 0 0 3.88 3.88h9.7v12.78l12.777-12.775h24.084a3.885 3.885 0 0 0 3.88-3.88V32.98a3.885 3.885 0 0 0-3.88-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 49h4v3h-4zM60 49h4v3h-4zM50 49h4v3h-4zM9.7 36.861a1.934 1.934 0 0 1-1.372-.568l-7.76-7.76a1.94 1.94 0 1 1 2.744-2.744L9.7 32.177l6.388-6.389a1.94 1.94 0 1 1 2.744 2.744l-7.76 7.76a1.934 1.934 0 0 1-1.372.568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7 36.861a1.94 1.94 0 0 1-1.94-1.94v-7.76a27.164 27.164 0 0 1 53.3-7.4 1.94 1.94 0 1 1-3.734 1.055 23.284 23.284 0 0 0-45.686 6.345v7.76a1.94 1.94 0 0 1-1.94 1.94M26.87 53.012a1.936 1.936 0 0 1-.619-.1 27.309 27.309 0 0 1-14.089-10.917 1.94 1.94 0 1 1 3.249-2.121 23.414 23.414 0 0 0 12.078 9.361 1.94 1.94 0 0 1-.619 3.779"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewConversations);
export default __webpack_public_path__ + "static/media/icon-new-conversations.65ce3e06594e89cb045ba58acf9dbd77.svg";
export { ForwardRef as ReactComponent };